export default "__VITE_ASSET__54NKm42i__"